import { render, staticRenderFns } from "./AgreedDeductionDataTable.vue?vue&type=template&id=cb22b17e&scoped=true"
import script from "./AgreedDeductionDataTable.vue?vue&type=script&lang=js"
export * from "./AgreedDeductionDataTable.vue?vue&type=script&lang=js"
import style0 from "./AgreedDeductionDataTable.vue?vue&type=style&index=0&id=cb22b17e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb22b17e",
  null
  
)

export default component.exports